export const EVENTS = {
  ERRANDS: "ERRAND",
  OTHER: "OTHER",
  TRAVEL: "TRAVEL",
};
